import "../../assets/InfoCard.css";
import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { ParticipantInfo as p } from "../ParticipantInfo/ParticipantInfo.js";
const s = "_infoCard_nk7qr_1", d = "_participantInfo_nk7qr_21", m = "_participantInfo__subtext_nk7qr_26", l = "_cardItemsGroup_nk7qr_31", I = "_cardItem_nk7qr_31", u = "_cardItem__linkGroup_nk7qr_57", t = {
  infoCard: s,
  participantInfo: d,
  participantInfo__subtext: m,
  cardItemsGroup: l,
  cardItem: I,
  cardItem__linkGroup: u
}, f = ({ sectionTitle: a, sectionLinks: c }) => /* @__PURE__ */ o("div", { className: t.cardItem, children: [
  /* @__PURE__ */ r("p", { children: a }),
  /* @__PURE__ */ r("div", { className: t.cardItem__linkGroup, children: c.map(({ text: n, url: i, openInNewWindow: e }) => i ? /* @__PURE__ */ r(
    "a",
    {
      href: i,
      ...e && { target: "_blank" },
      children: n
    },
    n
  ) : /* @__PURE__ */ r("div", { children: n }, n)) })
] }, a), G = ({
  cardInfoList: a,
  cardSubtext: c,
  hideParticipantInfo: n,
  children: i,
  ...e
}) => /* @__PURE__ */ o("div", { className: t.infoCard, children: [
  /* @__PURE__ */ o("div", { className: t.participantInfo, children: [
    n ? null : /* @__PURE__ */ r(p, { ...e }),
    /* @__PURE__ */ r("div", { className: t.participantInfo__subtext, children: c })
  ] }),
  i ? /* @__PURE__ */ r("div", { children: i }) : null,
  a ? /* @__PURE__ */ r("div", { className: t.cardItemsGroup, children: a.map((_) => /* @__PURE__ */ r(
    f,
    {
      ..._
    },
    _.sectionTitle
  )) }) : null
] });
export {
  G as InfoCard
};
